import logoBoa from 'img/logo.svg'


export const mockQuoteFooter = {
  logo: {
    url: logoBoa,
  },
  contacts: {
    phone_de: '0800 33 55 88',
    phone_fr: '0800 31 03 20',
    email: 'info@boalingua.ch',
  },
}
